import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot
} from '@angular/router';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PaymentStore } from '../service/payment.store';
import { Observable } from 'rxjs/Observable';
import { Payment } from '../models/payment';

@Injectable()
export class FinalPaymentStatusResolver implements Resolve<any> {

  constructor(
    private translateService: TranslateService,
    private paymentStore: PaymentStore
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Payment[]> {
    const eventId = route.params[ 'id' ];
    if (!eventId) {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.GET_FINAL_PAYMENT_STATUS'));
    }

    return this.paymentStore.loadFinalPaymentStatusList(eventId);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/payment/final-payment-status.resolver.ts